/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ReportsStatusBarChart = ({ datasets, title , height="300px"}) => {

    const data = {
        labels: [''], // one group of bars
        datasets: datasets,
    };

    const options = {
        indexAxis: 'y', // horizontal bars
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                right: 15,   // <-- adds space below legend
            },
        },
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                    font: {
                        size: 8
                    },
                },
                position: "top",
            },
            tooltip: {
                intersect: true,
            },
            datalabels: {
                display: true,   // <-- hides numbers on bars
                anchor: "end",
                align: "end",
                color: "#000",  // Change label color
                font: {
                    size: 9,
                    weight: "bold",
                    family: "Roboto",
                },
            },
        },
        scales: {
            x: {
                stacked: false,
                display: true,
                grid: { display: false },
                 ticks: { 
                    display: true,
                    font: {
                        size: 10,   // <--- Change this to your desired size
                    },
                },
            },
            y: {
                stacked: false,
                display: true,
                grid: { display: false },
                ticks: { display: true },
            },
        },
    };

    return (
        <div style={{ width: '100%', height: height }}>
            <Bar data={data} options={options} />
        </div>
    );
};

export default ReportsStatusBarChart;
